/** @format */

import { useKey } from 'hooks';
import theme from 'theme/themes';
import { IThemeColor } from 'types';
import { KEY_CONTEXT } from 'utils';

export default () => {
  const { getKey } = useKey();
  const mode = getKey(KEY_CONTEXT.THEME_MODE) as IThemeColor;
  return {
    default: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.palette.primary[mode],
    },
  };
};
